<template>
    <!-- Figma P1 "Payment Summary" card -->
    <div
        class="w-full laptop:w-[300px] desktop:w-[350px] laptop:flex-shrink-0 shadow-[0px_0px_10px_0px_#0000001A] rounded-[20px] px-[15px] laptop:px-[20px] py-[20px] bg-white font-roboto">
        <div class="flex items-center gap-1 pb-[10px]">
            <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
            <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
            <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Payment Summary</p>
        </div>
        <div class="flex items-center justify-between gap-2 py-[12px] border-b-1 border-[#EFEFEF] text-[13px]">
            <span class="text-[#555555]">Quote ID:</span>
            <span class="font-medium text-[#333333]">{{ invoiceDetail?.quote_id ?? '-' }}</span>
        </div>
        <div class="flex items-center justify-between gap-2 py-[12px] border-b-1 border-[#EFEFEF] text-[13px]">
            <span class="text-[#555555]">Invoice ID:</span>
            <span class="font-medium text-[#333333]">{{ invoiceDetail?.id ?? '-' }}</span>
        </div>
        <div class="flex items-center justify-between gap-2 py-[12px] text-[13px]">
            <span class="text-[#555555]">Invoice Type:</span>
            <span class="font-medium text-[#333333] text-right">{{ invoiceDetail?.type ?? '-' }}</span>
        </div>
        <div class="flex items-center justify-between gap-2 mt-[5px] px-[15px] py-[14px] rounded-[8px] bg-[#F3F4F7]">
            <span class="text-[15px] font-bold text-[#333333]">Amount Due</span>
            <span class="text-[19px] font-bold text-[#0E2F7E]">${{ $helper.formatAmount(invoiceDetail?.amount ?? '0')
                }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: ['invoiceDetail']
}
</script>
